;(function () {
  if (typeof window === 'undefined') return

  window.propertyDocumentTags = [
  {
    "documentLabelEN": "sharingDeclaration",
    "documentLabelDE": "Teilungserklärung",
    "additionalDocumentLabel": "",
    "tagName": "10 Stammdaten/Teilungserklärung",
    "sourceType": "OTHER",
    "ocrState": "NO_OCR"
  },
  {
    "documentLabelEN": "managementContract",
    "documentLabelDE": "Verwaltervertrag",
    "additionalDocumentLabel": "",
    "tagName": "10 Stammdaten/Verwaltervertrag",
    "sourceType": "OTHER",
    "ocrState": "NO_OCR"
  },
  {
    "documentLabelEN": "caretaker",
    "documentLabelDE": "Hausmeister",
    "additionalDocumentLabel": "",
    "tagName": "40 Gebäudedienst/HausmeisterVertrag",
    "sourceType": "OTHER",
    "ocrState": "NO_OCR"
  },
  {
    "documentLabelEN": "cleaning",
    "documentLabelDE": "Gebäudereinigung",
    "additionalDocumentLabel": "",
    "tagName": "40 Gebäudedienst/GebäudereinigungVertrag",
    "sourceType": "OTHER",
    "ocrState": "NO_OCR"
  },
  {
    "documentLabelEN": "outdoor",
    "documentLabelDE": "Aussenanlage",
    "additionalDocumentLabel": "",
    "tagName": "30 Versorger/Außenanlage",
    "sourceType": "OTHER",
    "ocrState": "NO_OCR"
  },
  {
    "documentLabelEN": "winter",
    "documentLabelDE": "Winterdienst",
    "additionalDocumentLabel": "",
    "tagName": "40 Gebäudedienst/WinterdienstVertrag",
    "sourceType": "OTHER",
    "ocrState": "NO_OCR"
  },
  {
    "documentLabelEN": "heatingMaintenanceContract",
    "documentLabelDE": "Heizung",
    "additionalDocumentLabel": "",
    "tagName": "30 Versorger/Heizung",
    "sourceType": "OTHER",
    "ocrState": "NO_OCR"
  },
  {
    "documentLabelEN": "energyCertificate",
    "documentLabelDE": "Energieausweis",
    "additionalDocumentLabel": "",
    "tagName": "10 Stammdaten/Energieausweis",
    "sourceType": "OTHER",
    "ocrState": "NO_OCR"
  },
  {
    "documentLabelEN": "acMaintenanceContract",
    "documentLabelDE": "Klimaanlage",
    "additionalDocumentLabel": "",
    "tagName": "30 Versorger/Klimaanlage",
    "sourceType": "OTHER",
    "ocrState": "NO_OCR"
  },
  {
    "documentLabelEN": "tvContract",
    "documentLabelDE": "Kabel TV",
    "additionalDocumentLabel": "",
    "tagName": "30 Versorger/Kabel TV",
    "sourceType": "OTHER",
    "ocrState": "NO_OCR"
  },
  {
    "documentLabelEN": "internetContract",
    "documentLabelDE": "Internet",
    "additionalDocumentLabel": "",
    "tagName": "30 Versorger/Internet",
    "sourceType": "OTHER",
    "ocrState": "NO_OCR"
  },
  {
    "documentLabelEN": "legionnairesReport",
    "documentLabelDE": "Prüfbericht",
    "additionalDocumentLabel": "legionnaireLastReport",
    "tagName": "50 Objektreporting/LegionellenPrüfbericht",
    "sourceType": "OTHER",
    "ocrState": "NO_OCR"
  },
  {
    "documentLabelEN": "legionnairesHazard",
    "documentLabelDE": "Gefährdungsanalyse",
    "additionalDocumentLabel": "legionnaireHazardAnalysis",
    "tagName": "50 Objektreporting/Trinkwasseruntersuchung",
    "sourceType": "OTHER",
    "ocrState": "NO_OCR"
  },
  {
    "documentLabelEN": "legionnairesContract",
    "documentLabelDE": "Prüfinstitut",
    "additionalDocumentLabel": "legionnaireCompanyContract",
    "tagName": "30 Versorger/Trinkwasserbeprobung",
    "sourceType": "OTHER",
    "ocrState": "NO_OCR"
  },
  {
    "documentLabelEN": "detector",
    "documentLabelDE": "Rauchwarnmelder",
    "additionalDocumentLabel": "Wartungsvertrag",
    "tagName": "30 Versorger/Rauchwarnmelder",
    "sourceType": "OTHER",
    "ocrState": "NO_OCR"
  },
  {
    "documentLabelEN": "fireExtinguisher",
    "documentLabelDE": "Feuerlöscher",
    "additionalDocumentLabel": "",
    "tagName": "30 Versorger/Feuerlöscher",
    "sourceType": "OTHER",
    "ocrState": "NO_OCR"
  },
  {
    "documentLabelEN": "watertreatment",
    "documentLabelDE": "Wasseraufbereitung",
    "additionalDocumentLabel": "",
    "tagName": "30 Versorger/Wasseraufbereitung",
    "sourceType": "OTHER",
    "ocrState": "NO_OCR"
  },
  {
    "documentLabelEN": "smokeextraction",
    "documentLabelDE": "Rauchabzugsanlage",
    "additionalDocumentLabel": "",
    "tagName": "30 Versorger/Rauchabzugsanlage",
    "sourceType": "OTHER",
    "ocrState": "NO_OCR"
  },
  {
    "documentLabelEN": "ventilation",
    "documentLabelDE": "Lüftungsanlage",
    "additionalDocumentLabel": "",
    "tagName": "30 Versorger/Lüftungsanlage",
    "sourceType": "OTHER",
    "ocrState": "NO_OCR"
  },
  {
    "documentLabelEN": "garageDoor",
    "documentLabelDE": "TG-Tor",
    "additionalDocumentLabel": "",
    "tagName": "30 Versorger/Garage",
    "sourceType": "OTHER",
    "ocrState": "NO_OCR"
  },
  {
    "documentLabelEN": "elevator",
    "documentLabelDE": "Aufzug",
    "additionalDocumentLabel": "",
    "tagName": "50 Objektreporting/Aufzugsbericht",
    "sourceType": "OTHER",
    "ocrState": "NO_OCR"
  },
  {
    "documentLabelEN": "insuranceidentityversicherungsvertrag",
    "documentLabelDE": "Versicherungsvertrag Identität",
    "additionalDocumentLabel": "",
    "tagName": "20 Versicherung/Versicherungsvertrag Versicherungen",
    "sourceType": "OTHER",
    "ocrState": "NO_OCR"
  },
  {
    "documentLabelEN": "insurancewegbeiratversicherungsvertrag",
    "documentLabelDE": "Versicherungsvertrag WEG Beirat",
    "additionalDocumentLabel": "",
    "tagName": "20 Versicherung/Versicherungsvertrag WEG Beirat",
    "sourceType": "OTHER",
    "ocrState": "NO_OCR"
  },
  {
    "documentLabelEN": "insuranceweghausgrhaftversicherungsvertrag",
    "documentLabelDE": "Versicherungsvertrag WEG Haus-Grundbesitzer",
    "additionalDocumentLabel": "",
    "tagName": "20 Versicherung/Versicherungsvertrag WEG Haus-Grundbesitzer",
    "sourceType": "OTHER",
    "ocrState": "NO_OCR"
  },
  {
    "documentLabelEN": "insurancebuildingversicherungsvertrag",
    "documentLabelDE": "Versicherungsvertrag Wohngebäude",
    "additionalDocumentLabel": "",
    "tagName": "20 Versicherung/Versicherungsvertrag Wohngebäude",
    "sourceType": "OTHER",
    "ocrState": "NO_OCR"
  }
]
})()
